import { FC } from "react";
import { Card } from "react-bootstrap";
import LoadingBox from "./loading-box";
import { PiCaretLeftLight } from "react-icons/pi";
import FlexBox from "./flex-box";
import ErrorBox from "./error-box";

export interface SimpleCardProps extends React.HTMLAttributes<HTMLDivElement> {
  isShowAnimation?: boolean;
  title?: string;
  subtitle?: string;
  isTitleNoBg?: boolean;
  error?: string;
  action?: React.ReactNode;
  //actionSubtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  bg?: string;
  isLoading?: boolean;
  loadingMessage?: string;
  className?: string;
  isShowBackButton?: boolean;
  size?: "sm" | "lg";
  onBackButtonClick?: () => void;
}

const SimpleCard: FC<SimpleCardProps> = ({
  isShowAnimation = false,
  isTitleNoBg = false,
  title,
  subtitle,
  error,
  action,
  //actionSubtitle,
  children,
  footer,
  bg = "white",
  isLoading,
  loadingMessage,
  isShowBackButton,
  size = "lg",
  onBackButtonClick,
  ...props
}) => (
  <Card bg={bg} {...props}>
    {title && !isTitleNoBg && (
      <Card.Header>
        <FlexBox justifyContent="between" alignItems="center">
          <div>
            <FlexBox justifyContent="between" alignItems="center">
              {size === "lg" ? (
                <>
                  <h4 className={subtitle ? "" : "py-2"}>
                    {isShowBackButton && (
                      <PiCaretLeftLight
                        className="cursor-pointer"
                        onClick={onBackButtonClick}
                      />
                    )}{" "}
                    {title}
                  </h4>
                </>
              ) : (
                <strong>{title}</strong>
              )}

              {/* <div className="w-25 mw-30 text-end">{action}</div> */}
            </FlexBox>
            {subtitle && (
              <FlexBox
                alignItems="center"
                justifyContent="between"
                className=""
              >
                {subtitle && <small className="text-muted">{subtitle}</small>}
                {/* {actionSubtitle && <small className="text-muted">{actionSubtitle}</small>} */}
              </FlexBox>
            )}
          </div>
          <div className="w-25 mw-30 text-end text-nowrap">{action}</div>
        </FlexBox>
      </Card.Header>
    )}
    <Card.Body className={isShowAnimation && "media-object"}>
      {isTitleNoBg && (
        <>
          <FlexBox justifyContent="between" alignItems="center">
            {size === "lg" ? (
              <h4>
                {isShowBackButton && (
                  <PiCaretLeftLight
                    className="cursor-pointer"
                    onClick={onBackButtonClick}
                  />
                )}{" "}
                {title}
              </h4>
            ) : (
              <strong>{title}</strong>
            )}
            {action}
          </FlexBox>
          <FlexBox alignItems="center" justifyContent="between" className="">
            {subtitle && <small className="text-muted">{subtitle}</small>}
            {/* {actionSubtitle && <small className="text-muted">{actionSubtitle}</small>} */}
          </FlexBox>
        </>
      )}
      {isLoading ? (
        <LoadingBox message={loadingMessage} />
      ) : (
        <>
          {children}
          <>
            {error && (
              <>
                <br />
                <ErrorBox message={error} />
              </>
            )}
          </>
        </>
      )}
    </Card.Body>
    {footer && <Card.Footer>{footer}</Card.Footer>}
  </Card>
);

export default SimpleCard;
